// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-controls-button {
    margin-bottom: 3px;
    height: 50px;
    width: 50px;
    text-align: center;
    border:none;
    background-color: rgba(0, 0, 0, 0);
    color: var(--theme-text-color);
}

.zoom-controls-button:hover, .zoom-controls-button:focus {
    background-color: rgba(170, 170, 170, 0.2);
    color: var(--theme-text-color);
}

.plus-button, .digizoom-button {
    margin-bottom: 0;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    transition: none
}

.digizoom-button {
    font-size: 10px;
    padding: 0;
    background-color: rgb(255, 208, 0) !important;
}

.digizoom-button:hover {
    background-color: rgb(26, 32, 54) !important;
    color: white;
}

.digizoom-button-disabled {
    font-size: 10px;
    padding: 0;
    background-color: rgb(255, 208, 0) !important;
}

.digizoom-button-disabled:hover {
    background-color: rgb(255, 208, 0) !important;
    color: white;
}

.minus-button {
    margin-top: 0;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.zoom-level-button {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0 !important;
    height:48px;
    line-height: 48px !important;
    padding: 0;
    font-weight: bold;
    cursor: default !important;
    border: 1px solid transparent;
    border-color:#d9d9d9;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    display: inline-block;
    vertical-align: middle;
    border:none;
    line-height: normal;
}

.zoom-level-button:hover {
    background-color: rgba(0, 0, 0, 0);
    color: var(--theme-text-color);
}

.zoom-controls-icon {
    font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/zoom_controls.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,wCAAwC;IACxC;AACJ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;IAC7B,oBAAoB;IACpB,wCAAwC;IACxC,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".zoom-controls-button {\n    margin-bottom: 3px;\n    height: 50px;\n    width: 50px;\n    text-align: center;\n    border:none;\n    background-color: rgba(0, 0, 0, 0);\n    color: var(--theme-text-color);\n}\n\n.zoom-controls-button:hover, .zoom-controls-button:focus {\n    background-color: rgba(170, 170, 170, 0.2);\n    color: var(--theme-text-color);\n}\n\n.plus-button, .digizoom-button {\n    margin-bottom: 0;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    transition: none\n}\n\n.digizoom-button {\n    font-size: 10px;\n    padding: 0;\n    background-color: rgb(255, 208, 0) !important;\n}\n\n.digizoom-button:hover {\n    background-color: rgb(26, 32, 54) !important;\n    color: white;\n}\n\n.digizoom-button-disabled {\n    font-size: 10px;\n    padding: 0;\n    background-color: rgb(255, 208, 0) !important;\n}\n\n.digizoom-button-disabled:hover {\n    background-color: rgb(255, 208, 0) !important;\n    color: white;\n}\n\n.minus-button {\n    margin-top: 0;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.zoom-level-button {\n    margin-top: 0;\n    margin-bottom: 0;\n    border-radius: 0 !important;\n    height:48px;\n    line-height: 48px !important;\n    padding: 0;\n    font-weight: bold;\n    cursor: default !important;\n    border: 1px solid transparent;\n    border-color:#d9d9d9;\n    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n    display: inline-block;\n    vertical-align: middle;\n    border:none;\n    line-height: normal;\n}\n\n.zoom-level-button:hover {\n    background-color: rgba(0, 0, 0, 0);\n    color: var(--theme-text-color);\n}\n\n.zoom-controls-icon {\n    font-size: 21px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
